/* CANDYFUZZ THEME — scripts compartilhados */
(function(){
  'use strict';

  /* ---------- carrossel: setas ---------- */
  function initRails(){
    document.querySelectorAll('[data-rail-prev]').forEach(function(btn){
      if(btn.dataset.ready) return; btn.dataset.ready='1';
      btn.addEventListener('click', function(){
        var rail = document.getElementById(btn.dataset.railPrev);
        if(rail) rail.scrollBy({left: -(rail.clientWidth*0.8), behavior:'smooth'});
      });
    });
    document.querySelectorAll('[data-rail-next]').forEach(function(btn){
      if(btn.dataset.ready) return; btn.dataset.ready='1';
      btn.addEventListener('click', function(){
        var rail = document.getElementById(btn.dataset.railNext);
        if(rail) rail.scrollBy({left: rail.clientWidth*0.8, behavior:'smooth'});
      });
    });
  }

  /* ---------- video UGC: som ---------- */
  window.icUgcToggle = function(card){
    var v = card.querySelector('video');
    if(!v) return;
    var icon = card.querySelector('.cf-ugc-mute svg');
    if(v.muted){
      document.querySelectorAll('.cf-ugc-card video').forEach(function(o){ if(o!==v) o.muted=true; });
      v.muted=false;
      if(icon) icon.innerHTML='<path d="M11 5L6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a9 9 0 0 1 0 14"/>';
    } else {
      v.muted=true;
      if(icon) icon.innerHTML='<path d="M11 5L6 9H2v6h4l5 4z"/><path d="M22 9l-6 6M16 9l6 6"/>';
    }
  };

  /* ---------- galeria do produto ---------- */
  window.icSetMainImage = function(thumb){
    var main = document.getElementById('cf-main-image');
    var img = thumb.querySelector('img');
    if(main && img){ main.src = img.dataset.full || img.src; }
    thumb.parentElement.querySelectorAll('.cf-thumb').forEach(function(t){ t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  };

  /* ---------- quantidade ---------- */
  window.icQty = function(delta){
    var input = document.getElementById('cf-qty');
    if(!input) return;
    var v = parseInt(input.value,10) || 1;
    v = Math.max(1, v + delta);
    input.value = v;
  };

  /* ---------- menu mobile ---------- */
  function initMenu(){
    var btn = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-menu]');
    if(!btn || !nav || btn.dataset.ready) return;
    btn.dataset.ready='1';
    btn.addEventListener('click', function(){
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true':'false');
    });
  }

  /* ---------- quiz ---------- */
  /* ---------- quiz ---------- */
function initQuiz(){
  document.querySelectorAll('[data-quiz]').forEach(setupQuiz);
}

function setupQuiz(quiz){
  if(!quiz || quiz.dataset.quizReady === '2') return;
  quiz.dataset.quizReady = '2';

  var designMode = quiz.dataset.designMode === 'true';
  var progress = quiz.querySelector('[data-quiz-progress]');
  var bar = quiz.querySelector('[data-quiz-bar]');
  var counter = quiz.querySelector('[data-quiz-counter]');
  var resultsWrap = quiz.querySelector('[data-quiz-results]');
  var errorBox = quiz.querySelector('[data-quiz-error]');
  var diagnosticsBox = quiz.querySelector('[data-quiz-diagnostics]');

  var allSteps = Array.prototype.slice.call(
    quiz.querySelectorAll('.cf-quiz-step')
  );

  var allResultEls = Array.prototype.slice.call(
    quiz.querySelectorAll('[data-result]')
  );

  var answers = {};
  var stepByQuestion = {};

  var weights = [
    parseInt(quiz.dataset.weightQ1,10) || 2,
    parseInt(quiz.dataset.weightQ2,10) || 5,
    parseInt(quiz.dataset.weightQ3,10) || 1,
    parseInt(quiz.dataset.weightQ4,10) || 4,
    parseInt(quiz.dataset.weightQ5,10) || 3
  ];

  function warn(message){
    if(designMode && window.console && console.warn){
      console.warn('[CANDYFUZZ Quiz] ' + message);
    }
  }

  function fail(message){
    allSteps.forEach(function(step){
      step.classList.remove('is-active');
    });

    if(resultsWrap){
      resultsWrap.classList.remove('is-active');
    }

    if(progress){
      progress.hidden = true;
    }

    if(errorBox){
      errorBox.classList.add('is-active');

      if(designMode && message){
        errorBox.textContent =
          errorBox.textContent + ' Editor: ' + message;
      }
    }

    warn(message);
  }

  allSteps.forEach(function(step){
    var n = parseInt(
      step.getAttribute('data-question'),
      10
    );

    step.classList.remove('is-active');

    if(n >= 1 && n <= 5){
      if(!stepByQuestion[n]){
        stepByQuestion[n] = step;
      } else {
        warn(
          'Q' + n +
          ' está duplicada. O primeiro bloco será usado.'
        );
      }
    }
  });

  for(var q = 1; q <= 5; q++){
    if(!stepByQuestion[q]){
      fail(
        'Falta a pergunta Q' + q +
        '. O quiz precisa de Q1, Q2, Q3, Q4 e Q5.'
      );
      return;
    }
  }

  function parseCombinations(raw){
    if(!raw) return [];

    var matches = String(raw)
      .toUpperCase()
      .match(
        /(?:[ABCD]\s*[\/\s>-]\s*){4}[ABCD]|[ABCD]{5}/g
      ) || [];

    var seen = {};
    var parsed = [];

    matches.forEach(function(item){
      var combo = item.replace(/[^ABCD]/g,'');

      if(combo.length === 5 && !seen[combo]){
        seen[combo] = true;
        parsed.push(combo);
      }
    });

    return parsed;
  }

  var results = allResultEls.map(function(el,index){
    var configEl = el.querySelector('[data-result-config]');
    var config = {};

    try{
      config = configEl
        ? JSON.parse(configEl.textContent)
        : {};
    } catch(err){
      warn(
        'JSON inválido no resultado de ordem ' +
        (index + 1) + '.'
      );
    }

    return {
      key: String(
        config.key ||
        el.getAttribute('data-result') ||
        ''
      ),
      priority: parseInt(config.priority,10) || 0,
      combinations: parseCombinations(
        config.combinations || ''
      ),
      el: el,
      order: index
    };
  });

  var validResults = results.filter(function(result){
    return result.combinations.length > 0;
  });

  var exactOwners = {};
  var duplicateComboCount = 0;

  validResults.forEach(function(result){
    result.combinations.forEach(function(combo){
      if(!exactOwners[combo]){
        exactOwners[combo] = [];
      }

      exactOwners[combo].push(result);
    });
  });

  Object.keys(exactOwners).forEach(function(combo){
    if(exactOwners[combo].length > 1){
      duplicateComboCount++;

      warn(
        'A combinação ' +
        combo.split('').join('/') +
        ' aparece em ' +
        exactOwners[combo].length +
        ' resultados.'
      );
    }
  });

  function compareCandidates(a,b){
    if(b.priority !== a.priority){
      return b.priority - a.priority;
    }

    return a.order - b.order;
  }

  function chooseWinner(answerKey){
    var exact = validResults.filter(function(result){
      return result.combinations.indexOf(answerKey) !== -1;
    });

    if(exact.length){
      exact.sort(compareCandidates);
      return exact[0];
    }

    var best = [];
    var bestScore = -1;

    validResults.forEach(function(result){
      var resultBest = -1;

      result.combinations.forEach(function(combo){
        var score = 0;

        for(var i = 0; i < 5; i++){
          if(
            combo.charAt(i) ===
            answerKey.charAt(i)
          ){
            score += weights[i];
          }
        }

        if(score > resultBest){
          resultBest = score;
        }
      });

      if(resultBest > bestScore){
        bestScore = resultBest;
        best = [result];
      } else if(resultBest === bestScore){
        best.push(result);
      }
    });

    if(best.length){
      best.sort(compareCandidates);
      return best[0];
    }

    var fallbackKey =
      quiz.dataset.defaultResult || '';

    var fallback = results.filter(function(result){
      return result.key === fallbackKey;
    })[0];

    return fallback || results[0] || null;
  }

  function updateProgress(questionNumber){
    var safe = Math.max(
      1,
      Math.min(5,questionNumber)
    );

    if(counter){
      counter.textContent = safe + '/5';
    }

    if(bar){
      bar.style.width = (safe * 20) + '%';
    }

    if(progress){
      progress.setAttribute(
        'aria-valuenow',
        String(safe)
      );
    }
  }

  function showQuestion(questionNumber,focusHeading){
    allSteps.forEach(function(step){
      step.classList.remove('is-active');
    });

    var step = stepByQuestion[questionNumber];

    if(!step) return;

    step.classList.add('is-active');
    updateProgress(questionNumber);

    if(focusHeading){
      var heading = step.querySelector('.quiz-q');

      if(heading){
        window.setTimeout(function(){
          heading.focus({
            preventScroll:true
          });
        },40);
      }
    }
  }

  function showResult(){
    var answerKey = '';

    for(var q = 1; q <= 5; q++){
      answerKey += answers[q] || '';
    }

    if(answerKey.length !== 5){
      fail(
        'Nem todas as cinco respostas foram registradas.'
      );
      return;
    }

    var winner = chooseWinner(answerKey);

    if(!winner){
      fail(
        'Nenhum resultado possui combinações válidas.'
      );
      return;
    }

    allSteps.forEach(function(step){
      step.classList.remove('is-active');
    });

    allResultEls.forEach(function(el){
      el.classList.remove('is-active');
    });

    winner.el.classList.add('is-active');

    if(resultsWrap){
      resultsWrap.classList.add('is-active');
    }

    if(counter){
      counter.textContent = '5/5';
    }

    if(bar){
      bar.style.width = '100%';
    }

    if(progress){
      progress.setAttribute(
        'aria-valuenow',
        '5'
      );
    }

    var heading =
      winner.el.querySelector('.quiz-result-name');

    if(heading){
      window.setTimeout(function(){
        heading.focus({
          preventScroll:true
        });
      },50);
    }
  }

  function runDiagnostics(){
    if(!designMode || !diagnosticsBox){
      return;
    }

    var notes = [];

    if(duplicateComboCount){
      notes.push(
        duplicateComboCount +
        ' combinações aparecem em mais de um resultado.'
      );
    }

    var invalidResults = results.filter(function(result){
      return result.combinations.length === 0;
    });

    if(invalidResults.length){
      notes.push(
        invalidResults.length +
        ' resultado(s) estão sem combinações válidas.'
      );
    }

    var coverage = {};

    results.forEach(function(result){
      coverage[result.key] = 0;
    });

    var letters = ['A','B','C','D'];

    letters.forEach(function(a){
      letters.forEach(function(b){
        letters.forEach(function(c){
          letters.forEach(function(d){
            letters.forEach(function(e){
              var winner =
                chooseWinner(a+b+c+d+e);

              if(winner){
                coverage[winner.key] =
                  (coverage[winner.key] || 0) + 1;
              }
            });
          });
        });
      });
    });

    var unreachable = results.filter(function(result){
      return (coverage[result.key] || 0) === 0;
    });

    if(unreachable.length){
      notes.push(
        'Resultados que não vencem com a configuração atual: ' +
        unreachable.map(function(result){
          return result.key;
        }).join(', ') + '.'
      );
    }

    if(!notes.length){
      notes.push(
        'Configuração válida. As 1.024 combinações recebem um resultado.'
      );
    } else {
      notes.push(
        'As 1.024 combinações continuam recebendo um resultado.'
      );
    }

    diagnosticsBox.innerHTML =
      '<strong>Diagnóstico do quiz no editor</strong>' +
      notes.map(function(note){
        return '<div>• ' + note + '</div>';
      }).join('');

    diagnosticsBox.hidden = false;
  }

  quiz.querySelectorAll('.cf-quiz-opt').forEach(function(btn){
    btn.addEventListener('click',function(){
      var step = btn.closest('.cf-quiz-step');

      if(!step) return;

      var questionNumber = parseInt(
        step.getAttribute('data-question'),
        10
      );

      var answer = String(
        btn.getAttribute('data-answer') || ''
      ).toUpperCase();

      if(
        !(questionNumber >= 1 &&
          questionNumber <= 5) ||
        !/^[ABCD]$/.test(answer)
      ){
        return;
      }

      answers[questionNumber] = answer;

      if(questionNumber < 5){
        showQuestion(
          questionNumber + 1,
          true
        );
      } else {
        showResult();
      }
    });
  });

  var restart =
    quiz.querySelector('[data-quiz-restart]');

  if(restart){
    restart.addEventListener('click',function(){
      answers = {};

      if(resultsWrap){
        resultsWrap.classList.remove('is-active');
      }

      allResultEls.forEach(function(el){
        el.classList.remove('is-active');
      });

      if(errorBox){
        errorBox.classList.remove('is-active');
      }

      if(progress){
        progress.hidden = false;
      }

      showQuestion(1,true);
    });
  }

  if(validResults.length === 0){
    warn(
      'Nenhum resultado possui combinações válidas.'
    );
  }

  runDiagnostics();
  showQuestion(1,false);
}

  
  /* ---------- init ---------- */
function init(){
  initRails();
  initMenu();
  initQuiz();
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
})();
